module.exports = __webpack_public_path__ + "assets/img/9.d921f8a3.png";